
<div class="library-header">
  <h3 class="">Documents</h3>
  <v-divider light></v-divider>
  <div class="d-flex flex-row align-center">
    <CSelect v-model="selectedSort" :changeFunction="setSort" :options="sort" :itemValue="'value'" :itemText="'text'"
      style="width: 20% !important"></CSelect>

    <CInput @input="searchWithDebounce" v-model="query" placeholder="Search for document" :type="'text'" :iconSrc="magniIcon"
       style="flex: 1 1 auto;" class="mx-2"></CInput>
    <div class="p-1 rounded-lg mx-2" :class="[cardView ? 'bg-primary' : 'border']">
      <v-icon class="" :color="cardView ? 'white' : 'grey'" @click="activateCard">mdi-view-grid</v-icon>
    </div>
    <div class="p-1 rounded-lg" :class="[!cardView ? 'bg-primary' : 'border']">
      <v-icon  :color="!cardView ? 'white' : 'grey'"
        @click="activateList">mdi-format-list-checkbox</v-icon>
    </div>

  </div>
</div>
